import axios from "axios";

export const PORTAL_TOKEN_KEY = "dnf_portal_token";

export function getPortalToken() {
  let t = localStorage.getItem(PORTAL_TOKEN_KEY);
  if (!t) {
    t = sessionStorage.getItem(PORTAL_TOKEN_KEY);
    if (t) {
      try { localStorage.setItem(PORTAL_TOKEN_KEY, t); } catch { /* private */ }
    }
  }
  return t;
}

export function setPortalToken(token) {
  try { localStorage.setItem(PORTAL_TOKEN_KEY, token); } catch { /* private */ }
  try { sessionStorage.setItem(PORTAL_TOKEN_KEY, token); } catch { /* private */ }
}

export function portalApi() {
  const t = getPortalToken();
  return axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    headers: t ? { Authorization: `Bearer ${t}` } : {},
  });
}

export async function uploadPortalFile(file) {
  const { data: sig } = await portalApi().get("/portal/solicitudes/cloudinary-signature");
  const fd = new FormData();
  fd.append("file", file);
  fd.append("api_key", sig.api_key);
  fd.append("timestamp", sig.timestamp);
  fd.append("signature", sig.signature);
  fd.append("folder", sig.folder);
  const isRaw = !file.type.startsWith("image/");
  const resourceType = isRaw ? "raw" : "image";
  const res = await axios.post(
    `https://api.cloudinary.com/v1_1/${sig.cloud_name}/${resourceType}/upload`, fd);
  return { nombre: file.name, url: res.data.secure_url, tipo: file.type, tamano: file.size };
}
